import Carousel from 'Assets/js/lib/carousel'
;(function () {
  const components = {
    rewardsTableCarousel: SAXX.Init.Component((node) => {
      new Carousel(node, {
        cell: '.rewards-table--column',
        initial: Number(node.getAttribute('data-initial')),
      })
    }),
  }
  Object.assign(SAXX.Init.Components, components)
})()
